var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThrift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6991"
    },
    d: "M256,0L256,0c-43.879,0-79.448,35.57-79.448,79.448v267.857c0,9.365,3.72,18.346,10.343,24.968 L256,441.379l69.106-69.106c6.622-6.622,10.343-15.604,10.343-24.968V79.448C335.448,35.57,299.879,0,256,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDC64"
    },
    points: "335.448,150.069 256,229.517 256,282.483 335.448,203.034 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC850"
    },
    points: "335.448,256 256,335.448 256,379.586 335.448,300.138 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF507D"
    },
    d: "M176.552,79.448v267.857c0,9.365,3.721,18.346,10.343,24.968L256,441.379V0 C212.121,0,176.552,35.57,176.552,79.448z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC850"
    },
    points: "176.552,203.034 256,282.483 256,326.621 176.552,247.172 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M176.552,79.448v17.655L256,176.552v-52.966l-73.703-73.703 C178.625,59.029,176.552,68.99,176.552,79.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D2850"
    },
    d: "M264.828,286.138l70.621-70.621v-24.966l-70.621,70.621v-28l41.551-41.551 c3.448-3.448,3.448-9.035,0-12.483s-9.035-3.448-12.483,0l-29.068,29.069v-84.621c0-0.483-0.052-1.026-0.129-1.5 c-0.301-1.818-1.164-3.491-2.465-4.793L186.27,41.367c-3.06,5.591-5.386,11.619-7.038,17.924l67.94,67.906v36.871l-70.621-70.621 v24.966l70.621,70.621V305.31l-29.069-29.069c-3.448-3.448-9.035-3.448-12.483,0c-3.448,3.448-3.448,9.035,0,12.483l41.553,41.553 v172.896c0,4.879,3.948,8.828,8.828,8.828c4.879,0,8.828-3.948,8.828-8.828V383.242l70.621-70.621v-24.966l-70.621,70.621V286.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDC64"
    },
    d: "M256,79.448l56.179-56.179c-5.972-5.972-12.93-10.925-20.549-14.761L256,44.138V79.448z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrift);
export default __webpack_public_path__ + "static/media/thrift.f01d4d03f09caf7d3dae646d8d3845a2.svg";
export { ForwardRef as ReactComponent };